import React from 'react';
import { Form } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useGetCompanies } from '@/hooks/useGetCompanies';
import { SelectOptions } from '@/components/ui/SelectOptions';
import * as S from '@/components/Settings/DataExtraction/styles';

const { useFormInstance, useWatch } = Form;

export function CompanyFormItem() {
	const form = useFormInstance();
	const organization_id: string = useWatch(['general_information', 'organization_id']);
	const companies = useGetCompanies({ organization_id });

	function handleOnChange(): void {
		form.setFieldValue(['general_information', 'sector_id'], undefined);
		form.setFieldValue(['general_information', 'line_id'], undefined);
		form.setFieldValue(['general_information', 'workstation_id'], undefined);
	}

	const isDisabled: boolean = !organization_id;

	return (
		<S.CustomFormItem
			name={['general_information', 'company_id']}
			label={I18n.get('Industrial site')}
			labelCol={{ span: 24 }}
			rules={[{ required: true, message: I18n.get('Industrial site is required') }]}
		>
			<SelectOptions
				allowClear
				disabled={isDisabled}
				options={companies.data}
				onChange={handleOnChange}
				loading={companies.isFetching}
				placeholder={I18n.get('Industrial site')}
			/>
		</S.CustomFormItem>
	);
}
